import React from "react";
import { CustomTooltip } from "../common-components/StyledComponents";
import { ChatBotRelative } from "../jobs/style";
import { IconButton, Typography } from "@mui/material";
import { ReactComponent as ChatBotIcon } from "../../assets/images/ChatBotIcon.svg";
import { ReactComponent as SupportHaley } from "../../assets/images/SupportHaley.svg";
import { CustomDiv } from "./style";

export default function ChatBotLabelText({
  handleToggleDrawer,
  chatBotData,
  title,
}) {
  const storage = JSON.parse(localStorage.getItem("credential"));
  return (
    <ChatBotRelative bottom={"11rem"}>
      <CustomTooltip
        title={
          <CustomDiv>
            <Typography color="#0070F2" fontWeight={600} fontSize={"16px"}>
              Hi, {storage?.username}
            </Typography>
            <Typography color="#000" fontSize={"14px"} marginTop={"5px"}>
              {title ||
                "My name is Hailey. I am here to help with your support needs"}
            </Typography>
            <Typography
              color="#000"
              fontSize={"10px"}
              fontWeight={500}
              textAlign={"end"}
              marginTop={"5px"}
            >
              Click on the icon to start Chatting
            </Typography>
          </CustomDiv>
        }
        arrowHeight={{
          width: "23px",
          height: "16px",
          marginBottom: "-1rem !important",
        }}
        boxShadow={"0px 1px 2px 0px rgba(16, 24, 40, 0.05)"}
        beforeArrowHeight={{
          width: "23px",
          height: "16px",
        }}
        borderRadius={"10px"}
        backgroundColor="#fff"
        placement="top-end"
        border={"2px solid #D5DADD"}
      >
        <IconButton onClick={handleToggleDrawer} style={{ padding: "0px" }}>
          {chatBotData.selectedValue === "Candidate" ||
          chatBotData.selectedValue === "Job" ? (
            <ChatBotIcon />
          ) : (
            <SupportHaley />
          )}
        </IconButton>
      </CustomTooltip>
    </ChatBotRelative>
  );
}
